
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.836 40.292H28.545v-29.79h6.988v8.621l5.303 16.926v4.243zm-10.6-31.791h3.816V6.854h-3.816v1.647zm0-3.647h3.816V4h-3.816v.854zm-3.691 14.391h-8.254v-3.738h8.254v3.738zm-4.127-6.786c.635 0 1.148.401 1.148.896H21.27c0-.495.513-.896 1.148-.896zm-6.127 1.048v26.785H4v-4.243l5.256-16.625.047-8.922h6.988v3.005zm-5.508-5.006h3.814V6.854h-3.814v1.647zm0-3.647h3.814V4h-3.814v.854zm26.75 14.115V8.502h-1.48V2h-7.817v6.502h-1.691v5.005h-1.357a2.954 2.954 0 00-2.77-1.956c-1.277 0-2.357.82-2.769 1.956h-1.358V8.502h-1.693V2H8.783v6.502h-1.48v10.467L2.047 35.593 2 42.292h16.291V21.245h8.254v21.047h16.291v-6.397l-5.303-16.926z","fill":"#020303","fill-rule":"evenodd"}})])
          )
        }
      }
    